// extracted by mini-css-extract-plugin
module.exports = {"swiper":"imageViewer_swiper__xzA42","showAction":"imageViewer_showAction__lVoCL"};